import { Encoder, Utils } from '@everyboard/lib';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { MoveWithTwoCoords } from '../../jscaip/MoveWithTwoCoords';
export class ConnectSixFirstMove extends MoveCoord {
    static of(coord) {
        return new ConnectSixFirstMove(coord.x, coord.y);
    }
    static encoder = MoveCoord.getEncoder(ConnectSixFirstMove.of);
    constructor(x, y) {
        super(x, y);
    }
    toString() {
        return 'ConnectSixFirstMove(' + this.coord.x + ', ' + this.coord.y + ')';
    }
}
export class ConnectSixDrops extends MoveWithTwoCoords {
    static encoder = MoveWithTwoCoords.getEncoder(ConnectSixDrops.of);
    static of(first, second) {
        Utils.assert(first.equals(second) === false, 'COORDS_SHOULD_BE_DIFFERENT');
        return new ConnectSixDrops(first, second);
    }
    toString() {
        return 'ConnectSixDrops(' + this.getFirst().toString() + ', ' + this.getSecond().toString() + ')';
    }
    equals(other) {
        const thisFirst = this.getFirst();
        const otherFirst = other.getFirst();
        const thisSecond = this.getSecond();
        const otherSecond = other.getSecond();
        if (thisFirst.equals(otherFirst) && thisSecond.equals(otherSecond)) {
            return true;
        }
        else if (thisFirst.equals(otherSecond) && thisSecond.equals(otherFirst)) {
            return true;
        }
        else {
            return false;
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var ConnectSixMove;
(function (ConnectSixMove) {
    function isFirstMove(move) {
        return move instanceof ConnectSixFirstMove;
    }
    ConnectSixMove.isFirstMove = isFirstMove;
    function isDrop(move) {
        return move instanceof ConnectSixDrops;
    }
    ConnectSixMove.isDrop = isDrop;
    ConnectSixMove.encoder = Encoder.disjunction([ConnectSixMove.isFirstMove, ConnectSixMove.isDrop], [ConnectSixFirstMove.encoder, ConnectSixDrops.encoder]);
})(ConnectSixMove || (ConnectSixMove = {}));
